import { Dropdown } from '~/components2/Dropdown';
import Button from '~/components2/forms/Button';
import newDownloadStore from './store';

type Props = {
  downloadArea: number | null;
};

export default function GlobalCommands({ downloadArea }: Props) {
  return (
    <Dropdown
      side="right"
      align="start"
      triggerElement={
        <Button
          alternate
          icon="lightning"
          size="icon"
          aria-label="Layer actions"
          data-testid="new-download-global-commands-button"
        />
      }
      items={[
        {
          type: 'simple',
          label: 'Turn Off All Layers',
          onClick: () => newDownloadStore.toggleAllLayers(false),
        },
        {
          type: 'simple',
          label: 'Turn On All Layers',
          onClick: () => newDownloadStore.toggleAllLayers(true),
        },
        { type: 'separator' },
        {
          type: 'simple',
          label: 'Expand All Sections',
          onClick: () => newDownloadStore.toggleAllSections(true),
        },
        {
          type: 'simple',
          label: 'Collapse All Sections',
          onClick: () => newDownloadStore.toggleAllSections(false),
        },
      ]}
    />
  );
}
